import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setFilterVisible } from '../store/actions';

const useToggleFilter = () => {
  const dispatch = useDispatch();

  const toggleFilter = useCallback(
    (visible) => {
      dispatch(setFilterVisible(visible));
    },
    [dispatch]
  );

  return toggleFilter;
};

export default useToggleFilter;
